// extracted by mini-css-extract-plugin
module.exports = {"block":"PredictionStatus_block__aGa0O","prediction":"PredictionStatus_prediction__SzDLZ","rpmText":"PredictionStatus_rpmText__1DcB0"};